<!-- start usage -->
<!-- <div v-if="false" class="row">
  <c-table
    :columns="tableColumns"
    :rows="rows"
    :dataRows="dataRows"
    :actions="tableActions"
  >
    <template v-slot:cell="{ row, cell, column }">
      <span v-if="cell?.label || cell === 'age'"
        >{{row[cell?.label || cell]}} year olds</span
      >
    </template>
    <template v-slot:action="{ row }">
      <span @click="detailRow(row)">Detail</span>
    </template>
  </c-table>
</div> -->
<!-- end usage -->
<div class="main-table">
  <div
    class="table-scroll"
    :style="styleList"
    ref="tableBody"
    @scroll="handleScroll"
  >
    <table class="table wh800">
      <thead>
        <tr>
          <th
            v-for="column in columns"
            :key="column"
            :class="column?.className || ''"
            v-show="!column?.hidden"
          >
            {{ $t(column?.label || column) }}
          </th>
        </tr>
      </thead>
      <tbody v-if="!loading">
        <tr v-for="(item, index) in dataRows" :key="index" class="hover-list">
          <td
            v-for="(cell, key) in rows"
            :key="key"
            :class="cell?.className || ''"
            v-show="!cell?.hidden"
          >
            <slot name="cell" :cell="cell?.label || cell" :row="item">
              <span v-html="tdValue(cell, item)"></span>
            </slot>
          </td>
          <td
            v-if="actions?.value && actions?.value.length"
            :class="actions?.className || ''"
            :style="hidden ? 'overflow: hidden !important;' : 'overflow: visible !important;'"
          >
            <div class="txt-action-path">
              <div
                v-for="(action, i) in actions?.value"
                :key="i"
                class="item-action"
              >
                <span v-if="!action?.type">
                  <span
                    v-if="action?.isDisabled || handleCondition(action, item)"
                    :class="[action?.className || '', action?.isDisabled || handleCondition(action, item) ? className(action?.className) : '']"
                  >
                    {{ $t(action?.label || action) }}
                  </span>
                  <span
                    v-else
                    @click="handleAction(action, item)"
                    :class="[action?.className || '', action?.isDisabled || handleCondition(action, item) ? className(action?.className) : '']"
                  >
                    {{ $t(action?.label || action) }}
                  </span>
                </span>
                <div v-else class="image-action">
                  <img
                    v-if="action?.isDisabled || handleCondition(action, item)"
                    :src="action?.type"
                    :class="[action?.className || '', action?.isDisabled || handleCondition(action, item) ? className(action?.className) : '']"
                    alt=""
                  />
                  <img
                    v-else
                    @click="handleAction(action, item)"
                    :src="action?.type"
                    :title="$t(action?.label || action)"
                    :class="[action?.className || '', action?.isDisabled || handleCondition(action, item) ? className(action?.className) : '']"
                    alt=""
                  />
                </div>
              </div>
              <div v-if="isOption" class="custom-select">
                <CustomDropdown
                  @change="onChangeDropdown"
                  :item="item"
                  :rows="rowOptions"
                ></CustomDropdown>
                <!-- <select
                  v-model="tableRowOptions"
                  class="ml8"
                  @change="$emit('onSelectTableAction', {...item, stockTypeId: tableRowOptions})"
                >
                  <template v-for="option in rowOptions" :key="option.id">
                    <option
                      v-if="$psm(option.permissionKey)"
                      :value="option.id"
                    >
                      {{ $t(option.name) }}
                    </option>
                  </template>
                </select> -->
              </div>
              <slot name="action" v-bind:row="item"></slot>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div v-if="loading || isSecondLoading" class="loading-style">
      <c-loading :textLoading="textLoading"></c-loading>
    </div>
    <div
      v-if="!loading && !isSecondLoading && dataRows && !dataRows.length"
      class="loading-style"
    >
      <c-empty @handler="$emit('handler')" :is_try_again="true"></c-empty>
    </div>
  </div>
</div>
